import { Component, Input } from '@angular/core';

/**
 * Monty classifier tag chip (088): single letter + color, muted N, optional
 * orange dot when an open proposal awaits the operator. Pure presentational —
 * renders nothing when no tag is present.
 */
@Component({
	selector: 'app-monty-tag',
	templateUrl: './monty-tag.component.html',
	styleUrls: ['./monty-tag.component.scss'],
})
export class MontyTagComponent {
	@Input() tag: 'P' | 'Q' | 'W' | 'C' | 'N' | null | undefined;
	@Input() open: boolean | null | undefined = false;
}
